import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import Link from '../Link/Link.js';

const TabLink = /*#__PURE__*/ React.forwardRef((_param, ref)=> {
    var { isActive , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "isActive",
        "className"
    ]);
    return React.createElement(Link, swcHelpers.extends({}, rest, {
        ref: ref,
        className: classnames('tab', className, {
            _is_active: isActive
        })
    }));
});
TabLink.displayName = 'TabLink';

export { TabLink as default };
//# sourceMappingURL=TabLink.js.map
